
<div class="header-toolbar">
  <h1>
    Opérations
    <span class="tag" *ngIf="filter.search">
      <span class="text">Recherche: {{ filter.search }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearSearch()"></t-icon>
    </span>

    <span class="tag" *ngIf="filter.category">
      <span class="text">Catégorie: {{ filter.category }}</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearCategory()"></t-icon>
    </span>

    <span class="tag" *ngIf="filter.category === ''">
      <span class="text">Catégorie: Non catégorisée</span>
      <t-icon name="close" title="Supprimer ce filtre" (click)="clearCategory()"></t-icon>
    </span>
  </h1>
</div>

<!-- Toolbar -->
<div class="main btn-toolbar">

  <div class="btn-group">    
    <div class="content">
      
      <a class="btn" [routerLink]="'/operations/new'">
        <t-icon name="add"></t-icon>
        <span class="text">Ajouter</span>
      </a>
      <button class="btn" (click)="applyFilter()">
        <t-icon name="search"></t-icon>
        <span class="text">Filtrer</span>
      </button>

    </div>
  </div>

</div>
<!-- /Toolbar -->

<table>

  <thead>
    <tr>
      <th>Nom</th>
      <th style="width: 200px">Catégorie</th>
      <th style="width: 150px">Dernière révision</th>
      <th style="width: 170px">Nombre d'exécutions</th>
      <th style="width: 170px">Nombre de révisions</th>
      <th style="width: 100px;"></th>
    </tr>
  </thead>

  <tbody *ngIf="operations && operations.length > 0">
    <tr *ngFor="let operation of operations" (click)="showRevisions(operation, $event)">
      <td name="Nom">
        {{ operation.name }}
      </td>
      <td name="Catégorie" style="width: 200px">
        {{ operation.category ? operation.category : '-' }}
      </td>
      <td name="Dernière révision" style="width: 150px">
        {{ operation.revisions.length > 0 ? operation.revisions[0].number : '-' }}
      </td>
      <td name="Nombre d'exécutions" class="text-center" style="width: 170px">
        {{ operation.executions_count }}
      </td>
      <td name="Nombre de révisions" class="text-center" style="width: 170px">
        {{ operation.revisionsCount }}
      </td>
      <td style="width: 100px;" class="actions">
        <a class="action-btn" title="Modifer" [routerLink]="['/operations', operation.id, 'edit']">
          <t-icon name="mode_edit"></t-icon>
        </a>
        <a class="action-btn" title="Supprimer" (click)="delete(operation)">
          <t-icon name="delete"></t-icon>
        </a>
      </td>
    </tr>
  </tbody>

  <tbody *ngIf="!operations || operations.length == 0">
    <tr>
      <td class="text-center" colspan="6">
        <ng-container *ngIf="operations && operations.length == 0">
          Aucune opération n'a été trouvée
        </ng-container>
        <ng-container *ngIf="!operations">
          Chargement...
        </ng-container>
      </td>
    </tr>
  </tbody>

</table>

<div class="pagination" *ngIf="operations">
  <button class="btn btn-gray" (click)="fetchMore()" *ngIf="operations.length < operationsCount">
    <t-icon name="arrow_downward"></t-icon>
    <span class="text">Afficher plus</span>
  </button>
  <div class="page-number">
    {{ operations.length }} / {{ operationsCount }}
  </div>
</div>